import { prettify, renderDeviceName, renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { devices } from "../../components/DeviceComponents";

const columns = [
  {
    size: 120,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorFn: (row) => renderDeviceName(row.device_type),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Tipo di Dispositivo",
  },
  {
    size: 50,
    header: "Dispositivo",
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorKey: "name",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  },
  {
    size: 80,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    accessorKey: "serial_number",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "MAC address",
  },
  {
    size: 5,
    accessorKey: "is_installed",
    enableColumnFilter: false, // TODO
    accessorFn: (row) => (row.is_installed ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Installato",
  },
  {
    size: 5,
    accessorKey: "is_online",
    enableColumnFilter: false, // TODO
    accessorFn: (row) => (row.is_online ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Online",
  },
];

export default columns;
